/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from '@msdyn365-commerce/core';
//import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions/';
import * as DataServiceEntities from './DataServiceEntities.g';
import { mWPGetQuotationsByQuotationIdAsync } from './DataActionExtension.g';

/**
 * GetQuotationById Input Action
 */
export class GetQuotationByIdInput implements Msdyn365.IActionInput {
    public readonly quotationId: string;

    constructor(quotationId: string) {
        this.quotationId = quotationId;
    }
    public getCacheKey = (): string => `Quotation-${this.quotationId}`;
    public getCacheObjectType = (): string => 'Quotations';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

/**
 * Validates the user's authentication and returns `GetQuotationByIdInput`
 * @throws Error if the user is not authenticated
 */
const createGetQuotationByIdInput = (
    user: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>,
    quotationId: string
): Msdyn365.IActionInput => {
    if (!user.requestContext.user.isAuthenticated) {
        throw new Error('Unable to fulfill request. User is not authenticated.');
    }
    return new GetQuotationByIdInput(quotationId);
};

/**
 * Action to get a quotation by calling `mWPGetQuotationsByQuotationIdAsync`
 */
export async function tasGetQuotationByIdAction(
    input: GetQuotationByIdInput,
    ctx: Msdyn365.IActionContext
): Promise<DataServiceEntities.IMWPQuotationsByQuotIdEntity> {
    const quotationId = input.quotationId;
    if (!quotationId) {
        return Promise.reject('Quotation ID not provided');
    }
    return mWPGetQuotationsByQuotationIdAsync({ callerContext: ctx, bypassCache: 'getAndPut' }, quotationId);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<DataServiceEntities.IMWPQuotationsByQuotIdEntity>>tasGetQuotationByIdAction,
    id: 'TASGetQuotationById',
    input: createGetQuotationByIdInput
});
